module.exports = __webpack_public_path__ + "static/img/lmyLogo.3a51599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lmyLogo.png
// module id = CUMw
// module chunks = 1